"use client";

import { snakize } from "@repo/edtech-shared";
import useSWRMutation from "swr/mutation";

import { API_URLS } from "./constants";
import { fetcher } from "./utils";

type AgreementInfo = {
  unit: string,
  publication: string,
  material: string,
};

type GenerateCodeRequest = {
  action: string,
  agreementInfo: AgreementInfo,
};

type GenerateCodeSuccessResponse = {
  case: 0,
  data: {
    ttl: number,
  },
  phone: string,
};

type GenerateCodeAlreadyExistsResponse = {
  case: 1,
  data: {
    ttl: number,
  },
  phone: string,
};

type GenerateCodeResponse = GenerateCodeSuccessResponse | GenerateCodeAlreadyExistsResponse;

type GenerateCodeResult = {
  ttl: number,
  alreadyExists: boolean,
  phone: string,
};

export const useGenerateCode = () => {
  return useSWRMutation(API_URLS.CODES_GENERATE,
    async (_url, { arg }: { arg: GenerateCodeRequest }): Promise<GenerateCodeResult> => {
      const res = await fetcher<GenerateCodeResponse>({
        url: API_URLS.CODES_GENERATE,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(snakize(arg)),
      });

      return {
        ttl: res.data.ttl,
        alreadyExists: res.case === 1,
        phone: res.phone,
      };
    });
};
